export interface SpreadsheetDto {
  id: string;
  name: string;
  owner: string;
  last_opened?: string;
}

export interface Spreadsheet {
  id: string;
  name: string;
  owner: string;
  lastOpened?: Date;
}

export interface WorksheetDto {
  id: string;
  name: string;
}

export interface Worksheet {
  id: string;
  name: string;
}

export function mapDtoToSpreadsheet({ id, name, owner, last_opened }: SpreadsheetDto): Readonly<Spreadsheet> {
  return {
    id,
    name,
    owner,
    lastOpened: last_opened ? new Date(last_opened) : undefined,
  };
}

export function mapDtoToWorksheet({ id, name }: WorksheetDto): Readonly<Worksheet> {
  return {
    id,
    name,
  };
}
